import { gql, TypedDocumentNode } from '@apollo/client';
import {
  CardPaymentStatusEnum,
  ExchangeStatusEnum,
} from '@libs/backend-common';

import { DefaultApiResponse, DefaultArg } from '@libs/graphql';
import { Asset } from '@libs/types';

type TransactionType = {
  id: number;
};

export enum PaymentMethod {
  CardRegister = 'CardRegister',
  CardRegisterTemporary = 'CardRegisterTemporary',
  CardSaveAndPayment = 'CardSaveAndPayment',
  CardlessPayment = 'CardlessPayment',
  RecurrentPayment = 'RecurrentPayment',
  SingleCardPayment = 'SingleCardPayment',
  Withdraw = 'Withdraw',
}

type DirectCryptoType = {
  neededAmount: number;
  status: ExchangeStatusEnum;

  receivedAmount: number;
  exchangePair: {
    baseAsset: Asset;
    quoteAsset: Asset;
  };
};

export type GetPaymentV2Res = {
  getPaymentV2: DefaultApiResponse<{
    amount: number;
    id: number | string;
    status: CardPaymentStatusEnum;
    transaction?: TransactionType;
    cardId?: number;
    directCryptoTransaction?: { exchange: DirectCryptoType };
    method?: PaymentMethod;
  }>;
};

export const getPaymentV2Query: TypedDocumentNode<
  GetPaymentV2Res,
  DefaultArg<{ paymentId: string }>
> = gql`
  query GetPaymentV2($record: GetPaymentRecord!) {
    getPaymentV2(record: $record) {
      amount
      id
      status
      cardId
      method
      transaction {
        id
      }
      directCryptoTransaction {
        exchange {
          status
          neededAmount
          receivedAmount
          exchangePair {
            baseAsset {
              code
              name
            }
            quoteAsset {
              code
              name
            }
          }
        }
      }
    }
  }
`;
